"use client";

import { c as _c } from "react/compiler-runtime";
import { TreatmentCaseSubjectFilter } from "@/widgets/treatment-case/ui/organisms";
import { memo, useEffect, useMemo, useRef, useState } from "react";
import useTreatmentCaseUIStore from "@/widgets/treatment-case/model/ui/store";
import { TextButton } from "@/shared/ui/atoms";
import { TreatmentCaseFilterResponse } from "@/shared/types/type/treatment";
import { useTranslations } from "next-intl";
interface TreatmentCaseFilterProps {
  filterList: TreatmentCaseFilterResponse;
  sticky?: boolean;
  subjectFilter?: boolean;
}
const TreatmentCaseFilter = t0 => {
  const $ = _c(58);
  const {
    filterList,
    sticky: t1,
    subjectFilter: t2
  } = t0;
  const sticky = t1 === undefined ? true : t1;
  const subjectFilter = t2 === undefined ? false : t2;
  const t = useTranslations();
  let t3;
  if ($[0] !== t) {
    t3 = t("commonMedicalTreatment.treatments.dentistry");
    $[0] = t;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t) {
    t4 = t("commonMedicalTreatment.treatments.dermatology");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t) {
    t5 = t("commonMedicalTreatment.treatments.plasticSurgery");
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = [t3, t4, t5];
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const CATEGORY_NAME_ORDER = t6 as const;
  const selectedCategoryId = useTreatmentCaseUIStore(_temp);
  const setSelectedCategoryId = useTreatmentCaseUIStore(_temp2);
  const setSelectedSubjectId = useTreatmentCaseUIStore(_temp3);
  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const lastScrollY = useRef(0);
  const isFilterVisibleRef = useRef(true);
  let t7;
  if ($[10] !== selectedCategoryId) {
    t7 = filter => (selectedCategoryId || 0) === filter;
    $[10] = selectedCategoryId;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const isSelected = t7;
  let t8;
  if ($[12] !== filterList || $[13] !== selectedCategoryId) {
    t8 = filterList.find(category => category.treatmentCategoryId === selectedCategoryId)?.treatmentSubjects ?? [];
    $[12] = filterList;
    $[13] = selectedCategoryId;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const subjectFilterList = t8;
  let t9;
  if ($[15] !== CATEGORY_NAME_ORDER) {
    t9 = name => {
      const i = CATEGORY_NAME_ORDER.indexOf(name as (typeof CATEGORY_NAME_ORDER)[number]);
      return i === -1 ? CATEGORY_NAME_ORDER.length : i;
    };
    $[15] = CATEGORY_NAME_ORDER;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const categoryNameSortKey = t9;
  let t10;
  if ($[17] !== setSelectedCategoryId || $[18] !== setSelectedSubjectId) {
    t10 = categoryId => {
      setSelectedCategoryId(categoryId);
      setSelectedSubjectId(0);
    };
    $[17] = setSelectedCategoryId;
    $[18] = setSelectedSubjectId;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const handleCategoryClick = t10;
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      const currentScrollY = window.scrollY;
      const isScrollingDown = currentScrollY > lastScrollY.current;
      if (Math.abs(currentScrollY - lastScrollY.current) < 30) {
        return;
      }
      lastScrollY.current = currentScrollY;
      if (isScrollingDown && currentScrollY > 20) {
        if (isFilterVisibleRef.current) {
          isFilterVisibleRef.current = false;
          setIsFilterVisible(false);
        }
      } else {
        if (!isScrollingDown) {
          if (!isFilterVisibleRef.current) {
            isFilterVisibleRef.current = true;
            setIsFilterVisible(true);
          }
        }
      }
    };
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const handleScroll = t11;
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = [];
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  useEffect(_temp5, t12);
  let t13;
  let t14;
  if ($[22] !== selectedCategoryId) {
    t13 = () => {
      if (selectedCategoryId !== 0) {
        window.addEventListener("scroll", handleScroll, {
          passive: true
        });
      }
      return () => {
        if (selectedCategoryId !== 0) {
          window.removeEventListener("scroll", handleScroll);
        }
      };
    };
    t14 = [selectedCategoryId];
    $[22] = selectedCategoryId;
    $[23] = t13;
    $[24] = t14;
  } else {
    t13 = $[23];
    t14 = $[24];
  }
  useEffect(t13, t14);
  let t15;
  if ($[25] !== isSelected) {
    t15 = filter_0 => `px-1 pt-1.5 pb-2.5 line-height-[22px] font-semibold ${isSelected(filter_0) ? "border-b-2 border-gray-800 text-gray-900" : "text-gray-400"}`;
    $[25] = isSelected;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const getTextButtonClassName = t15;
  let t16;
  if ($[27] !== categoryNameSortKey || $[28] !== filterList) {
    let t17;
    if ($[30] !== categoryNameSortKey) {
      t17 = (a, b) => categoryNameSortKey(a.treatmentCategoryName) - categoryNameSortKey(b.treatmentCategoryName);
      $[30] = categoryNameSortKey;
      $[31] = t17;
    } else {
      t17 = $[31];
    }
    t16 = [...filterList].sort(t17);
    $[27] = categoryNameSortKey;
    $[28] = filterList;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const sortedFilterList = t16;
  const t17 = `${sticky && "sticky top-0 z-10"} bg-white`;
  const t18 = `grid transition-[grid-template-rows] duration-200 ${isFilterVisible ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`;
  const t19 = getTextButtonClassName(0);
  let t20;
  if ($[32] !== handleCategoryClick) {
    t20 = () => handleCategoryClick(0);
    $[32] = handleCategoryClick;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t19 || $[35] !== t20) {
    t21 = <TextButton key="treatment-case-filter-category-0" text={"\uC804\uCCB4"} size={20} className={t19} onClick={t20} />;
    $[34] = t19;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== getTextButtonClassName || $[38] !== handleCategoryClick || $[39] !== sortedFilterList) {
    let t23;
    if ($[41] !== getTextButtonClassName || $[42] !== handleCategoryClick) {
      t23 = category_0 => <TextButton key={`treatment-case-filter-category-${category_0.treatmentCategoryId}`} text={category_0.treatmentCategoryName} size={20} className={getTextButtonClassName(category_0.treatmentCategoryId)} onClick={() => handleCategoryClick(category_0.treatmentCategoryId)} />;
      $[41] = getTextButtonClassName;
      $[42] = handleCategoryClick;
      $[43] = t23;
    } else {
      t23 = $[43];
    }
    t22 = sortedFilterList.map(t23);
    $[37] = getTextButtonClassName;
    $[38] = handleCategoryClick;
    $[39] = sortedFilterList;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[44] !== t21 || $[45] !== t22) {
    t23 = <div className="overflow-hidden"><div className="flex items-center gap-6 px-4 pt-[6px] border-b border-gray-200 overflow-x-auto">{t21}{t22}</div></div>;
    $[44] = t21;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t18 || $[48] !== t23) {
    t24 = <div className={t18}>{t23}</div>;
    $[47] = t18;
    $[48] = t23;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== selectedCategoryId || $[51] !== subjectFilter || $[52] !== subjectFilterList) {
    t25 = selectedCategoryId !== 0 && subjectFilter && <TreatmentCaseSubjectFilter subjectFilterList={subjectFilterList} />;
    $[50] = selectedCategoryId;
    $[51] = subjectFilter;
    $[52] = subjectFilterList;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t17 || $[55] !== t24 || $[56] !== t25) {
    t26 = <div className={t17}>{t24}{t25}</div>;
    $[54] = t17;
    $[55] = t24;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  return t26;
};
export default memo(TreatmentCaseFilter);
function _temp(s) {
  return s.selectedCategoryId;
}
function _temp2(s_0) {
  return s_0.setSelectedCategoryId;
}
function _temp3(s_1) {
  return s_1.setSelectedSubjectId;
}
function _temp4() {
  document.body.style.overflowAnchor = "";
}
function _temp5() {
  document.body.style.overflowAnchor = "none";
  return _temp4;
}